<div class="min-h-screen bg-white">

    <div
        class="grid min-h-screen
               lg:grid-cols-[0.82fr_1.38fr]"
    >

        <!-- ====================================================== -->
        <!-- LEFT · LOGIN -->
        <!-- ====================================================== -->

        <section
            class="relative
                   flex min-h-screen
                   items-center
                   justify-center
                   overflow-hidden
                   bg-[#fffdfb]
                   px-6 py-10
                   sm:px-10
                   lg:px-12
                   xl:px-16"
        >

            <!-- ================================================== -->
            <!-- DECORATION -->
            <!-- ================================================== -->

            <div
                class="pointer-events-none
                       absolute -left-40 -top-40
                       h-[420px] w-[420px]
                       rounded-full
                       bg-orange-100/50"
            ></div>

            <div
                class="pointer-events-none
                       absolute -left-28 -top-28
                       h-[320px] w-[320px]
                       rounded-full
                       border border-orange-200/60"
            ></div>

            <div
                class="pointer-events-none
                       absolute -bottom-52 -left-40
                       h-[420px] w-[420px]
                       rounded-full
                       bg-emerald-50/60
                       blur-2xl"
            ></div>


            <!-- ================================================== -->
            <!-- CONTENT -->
            <!-- ================================================== -->

            <div
                class="relative z-10
                       w-full
                       max-w-[470px]"
            >

                <!-- ================================================== -->
                <!-- BRAND -->
                <!-- ================================================== -->

                <div
                    class="mb-10
                           flex items-start
                           justify-between
                           gap-4"
                >

                    <div
                        class="flex items-center
                               gap-3.5"
                    >

                        <div
                            class="flex h-12 w-12
                                   shrink-0
                                   items-center
                                   justify-center
                                   rounded-2xl
                                   bg-gradient-to-br
                                   from-[#f26846]
                                   to-[#c8442e]
                                   text-lg
                                   font-bold
                                   text-white
                                   shadow-[0_12px_28px_rgba(200,68,46,0.22)]"
                        >
                            R
                        </div>


                        <div>

                            <div
                                class="text-xl
                                       font-extrabold
                                       tracking-tight
                                       text-slate-950"
                            >
                                Restaurant<span
                                    class="text-[#d65335]"
                                >OS</span>
                            </div>


                            <div
                                class="mt-0.5
                                       text-[9px]
                                       font-semibold
                                       tracking-[0.19em]
                                       text-slate-400"
                            >
                                RESTAURANT MANAGEMENT
                            </div>

                        </div>

                    </div>


                    <div
                        class="hidden
                               items-center
                               gap-2
                               rounded-full
                               border border-orange-100
                               bg-orange-50/90
                               px-3 py-1.5
                               text-[10px]
                               font-semibold
                               text-[#b94c34]
                               sm:flex"
                    >

                        <nz-icon
                            nzType="lock"
                            nzTheme="outline"
                        ></nz-icon>

                        Acceso seguro

                    </div>

                </div>


                <!-- ================================================== -->
                <!-- INTRO -->
                <!-- ================================================== -->

                <div class="mb-8">

                    <div
                        class="mb-3
                               inline-flex
                               items-center
                               gap-2
                               rounded-full
                               border border-orange-100
                               bg-[#fff3e9]
                               px-3 py-1.5
                               text-[10px]
                               font-semibold
                               text-[#c34e34]"
                    >

                        <span
                            class="h-1.5 w-1.5
                                   rounded-full
                                   bg-[#df6542]"
                        ></span>

                        Tu negocio, en un solo lugar

                    </div>


                    <h1
                        class="text-[34px]
                               font-extrabold
                               leading-[1.08]
                               tracking-[-0.035em]
                               text-slate-950
                               sm:text-[40px]"
                    >
                        Bienvenido de nuevo
                    </h1>


                    <p
                        class="mt-3
                               max-w-md
                               text-sm
                               leading-6
                               text-slate-500"
                    >
                        Administra tu restaurante,
                        sucursales, personal y operaciones
                        desde un solo lugar.
                    </p>

                </div>


                <!-- ================================================== -->
                <!-- FORM -->
                <!-- ================================================== -->

                <form
                    [formGroup]="loginForm"
                    (ngSubmit)="login()"
                    class="space-y-5"
                >

                    <!-- EMAIL -->

                    <div>

                        <label
                            class="mb-2
                                   block
                                   text-sm
                                   font-semibold
                                   text-slate-800"
                        >
                            Correo electrónico
                        </label>


                        <div class="group relative">

                            <nz-icon
                                nzType="mail"
                                nzTheme="outline"
                                class="pointer-events-none
                                       absolute
                                       left-4 top-1/2
                                       z-10
                                       -translate-y-1/2
                                       text-slate-400
                                       transition
                                       group-focus-within:text-[#d45a3c]"
                            ></nz-icon>


                            <input
                                nz-input
                                type="email"
                                formControlName="email"
                                placeholder="nombre@restaurante.com"

                                class="!h-[54px]
                                       !rounded-2xl
                                       !border-slate-200
                                       !bg-white
                                       !pl-11
                                       !text-sm
                                       !text-slate-800
                                       !shadow-[0_4px_20px_rgba(15,23,42,0.025)]
                                       transition
                                       hover:!border-slate-300
                                       focus:!border-[#df6a4c]
                                       focus:!shadow-[0_0_0_4px_rgba(223,106,76,0.08)]"
                            />

                        </div>


                        @if (
                            loginForm.controls.email.touched &&
                            loginForm.controls.email.invalid
                        ) {

                            <div
                                class="mt-2
                                       flex items-center
                                       gap-1.5
                                       text-xs
                                       font-medium
                                       text-red-500"
                            >

                                <nz-icon
                                    nzType="exclamation-circle"
                                    nzTheme="outline"
                                ></nz-icon>

                                Ingresa un correo electrónico válido.

                            </div>

                        }

                    </div>


                    <!-- PASSWORD -->

                    <div>

                        <div
                            class="mb-2
                                   flex items-center
                                   justify-between
                                   gap-3"
                        >

                            <label
                                class="text-sm
                                       font-semibold
                                       text-slate-800"
                            >
                                Contraseña
                            </label>


                            <button
                                type="button"
                                class="text-xs
                                       font-semibold
                                       text-[#c64b31]
                                       transition
                                       hover:text-[#a83e29]"
                            >
                                ¿Olvidaste tu contraseña?
                            </button>

                        </div>


                        <div class="group relative">

                            <nz-icon
                                nzType="lock"
                                nzTheme="outline"
                                class="pointer-events-none
                                       absolute
                                       left-4 top-1/2
                                       z-10
                                       -translate-y-1/2
                                       text-slate-400
                                       transition
                                       group-focus-within:text-[#d45a3c]"
                            ></nz-icon>


                            <input
                                nz-input
                                [type]="passwordVisible ? 'text' : 'password'"
                                formControlName="password"
                                placeholder="••••••••"

                                class="!h-[54px]
                                       !rounded-2xl
                                       !border-slate-200
                                       !bg-white
                                       !pl-11
                                       !pr-12
                                       !text-sm
                                       !text-slate-800
                                       !shadow-[0_4px_20px_rgba(15,23,42,0.025)]
                                       transition
                                       hover:!border-slate-300
                                       focus:!border-[#df6a4c]
                                       focus:!shadow-[0_0_0_4px_rgba(223,106,76,0.08)]"
                            />


                            <button
                                type="button"

                                class="absolute
                                       right-4 top-1/2
                                       z-10
                                       flex h-8 w-8
                                       -translate-y-1/2
                                       items-center
                                       justify-center
                                       rounded-lg
                                       text-slate-400
                                       transition
                                       hover:bg-slate-100
                                       hover:text-slate-700"

                                (click)="togglePassword()"
                            >

                                <nz-icon
                                    [nzType]="
                                        passwordVisible
                                            ? 'eye-invisible'
                                            : 'eye'
                                    "
                                    nzTheme="outline"
                                ></nz-icon>

                            </button>

                        </div>


                        @if (
                            loginForm.controls.password.touched &&
                            loginForm.controls.password.invalid
                        ) {

                            <div
                                class="mt-2
                                       flex items-center
                                       gap-1.5
                                       text-xs
                                       font-medium
                                       text-red-500"
                            >

                                <nz-icon
                                    nzType="exclamation-circle"
                                    nzTheme="outline"
                                ></nz-icon>

                                Ingresa tu contraseña.

                            </div>

                        }

                    </div>


                    <!-- REMEMBER -->

                    <div
                        class="flex
                               items-center
                               justify-between
                               pt-1"
                    >

                        <label
                            nz-checkbox
                            formControlName="rememberMe"
                            class="!text-sm !text-slate-600"
                        >
                            Mantener sesión iniciada
                        </label>

                    </div>


                    <!-- LOGIN -->

                    <button
                        nz-button
                        nzBlock
                        type="submit"
                        [nzLoading]="loading"

                        class="!mt-7
                               !h-[54px]
                               !rounded-2xl
                               !border-0
                               !bg-gradient-to-r
                               !from-[#c9472e]
                               !to-[#ed6845]
                               !text-sm
                               !font-bold
                               !text-white
                               !shadow-[0_14px_32px_rgba(201,71,46,0.24)]
                               transition
                               hover:!from-[#b83c28]
                               hover:!to-[#db5739]"
                    >

                        @if (!loading) {

                            <span>
                                Iniciar sesión
                            </span>


                            <nz-icon
                                nzType="arrow-right"
                                nzTheme="outline"
                                class="ml-2"
                            ></nz-icon>

                        }

                    </button>

                </form>


                <!-- ================================================== -->
                <!-- DIVIDER -->
                <!-- ================================================== -->

                <div
                    class="mt-7
                           flex items-center
                           gap-3"
                >

                    <div
                        class="h-px
                               flex-1
                               bg-slate-200"
                    ></div>


                    <span
                        class="text-[10px]
                               text-slate-400"
                    >
                        acceso empresarial
                    </span>


                    <div
                        class="h-px
                               flex-1
                               bg-slate-200"
                    ></div>

                </div>


                <!-- ================================================== -->
                <!-- SECURITY -->
                <!-- ================================================== -->

                <div
                    class="mt-6
                           rounded-2xl
                           border border-slate-100
                           bg-slate-50/70
                           px-4 py-3.5"
                >

                    <div
                        class="flex
                               items-start
                               gap-3"
                    >

                        <div
                            class="mt-0.5
                                   flex h-9 w-9
                                   shrink-0
                                   items-center
                                   justify-center
                                   rounded-xl
                                   bg-orange-50
                                   text-[#d85c3e]"
                        >

                            <nz-icon
                                nzType="safety-certificate"
                                nzTheme="outline"
                            ></nz-icon>

                        </div>


                        <div>

                            <div
                                class="text-xs
                                       font-semibold
                                       text-slate-700"
                            >
                                Acceso protegido
                            </div>


                            <p
                                class="mt-0.5
                                       text-[10px]
                                       leading-5
                                       text-slate-400"
                            >
                                Tus credenciales se utilizan
                                únicamente para acceder de forma
                                segura a RestaurantOS.
                            </p>

                        </div>

                    </div>

                </div>


                <!-- ================================================== -->
                <!-- LEGAL -->
                <!-- ================================================== -->

                <div
                    class="mt-6
                           border-t
                           border-slate-100
                           pt-5"
                >

                    <p
                        class="text-center
                               text-[10px]
                               leading-5
                               text-slate-400"
                    >

                        Al iniciar sesión aceptas los

                        <span
                            class="font-medium
                                   text-[#c65337]"
                        >
                            términos de uso
                        </span>

                        y

                        <span
                            class="font-medium
                                   text-[#c65337]"
                        >
                            políticas de privacidad
                        </span>

                        de RestaurantOS.

                    </p>

                </div>


                <!-- MOBILE FOOTER -->

                <div
                    class="mt-8
                           flex items-center
                           justify-between
                           text-[10px]
                           text-slate-400
                           lg:hidden"
                >

                    <span>
                        RestaurantOS © 2026
                    </span>


                    <span
                        class="flex items-center
                               gap-1.5"
                    >

                        <nz-icon
                            nzType="global"
                            nzTheme="outline"
                        ></nz-icon>

                        Español

                    </span>

                </div>

            </div>

        </section>


        <!-- ====================================================== -->
        <!-- RIGHT · HERO -->
        <!-- ====================================================== -->

        <section
            class="relative
                   hidden
                   min-h-screen
                   overflow-hidden
                   lg:block"
        >

            <!-- ================================================== -->
            <!-- BACKGROUND IMAGE -->
            <!-- ================================================== -->

            <img
    src="/images/login-restaurant-bg.png"
    alt=""
    class="absolute inset-0
           h-full w-full
           object-cover
           object-[94%_center]"
/>


            <!-- ================================================== -->
            <!-- READABILITY OVERLAY -->
            <!-- ================================================== -->

            <!--
                Más oscuro en la izquierda.
                Mucho más transparente a la derecha.

                Así el texto conserva contraste
                sin esconder la fotografía.
            -->

            <div
                class="absolute inset-0
                       bg-gradient-to-r
                       from-[#1c0e0a]/94
                       via-[#24120d]/52
                       to-[#140906]/5"
            ></div>


            <!-- LOWER VIGNETTE -->

            <div
                class="absolute inset-x-0
                       bottom-0
                       h-[27%]
                       bg-gradient-to-t
                       from-[#120806]/48
                       to-transparent"
            ></div>


            <!-- TOP VIGNETTE -->

            <div
                class="absolute inset-x-0
                       top-0
                       h-[18%]
                       bg-gradient-to-b
                       from-black/20
                       to-transparent"
            ></div>


            <!-- ================================================== -->
            <!-- VERY SUBTLE GRID -->
            <!-- ================================================== -->

            <div
                class="absolute inset-0
                       opacity-[0.015]"

                style="
                    background-image:
                        linear-gradient(
                            rgba(255,255,255,.8) 1px,
                            transparent 1px
                        ),
                        linear-gradient(
                            90deg,
                            rgba(255,255,255,.8) 1px,
                            transparent 1px
                        );

                    background-size:
                        58px 58px;
                "
            ></div>


            <!-- ================================================== -->
            <!-- CONTENT -->
            <!-- ================================================== -->

            <div
                class="relative z-10
                       flex min-h-screen
                       flex-col
                       px-10 py-9
                       xl:px-14
                       xl:py-11
                       2xl:px-16"
            >

                <!-- ================================================== -->
                <!-- TOP -->
                <!-- ================================================== -->

                <div
                    class="flex
                           items-center
                           justify-between"
                >

                    <div
                        class="inline-flex
                               items-center
                               gap-2.5
                               text-[9px]
                               font-semibold
                               uppercase
                               tracking-[0.30em]
                               text-orange-50/75"
                    >

                        <span
                            class="h-2 w-2
                                   rounded-full
                                   bg-[#ff8060]
                                   shadow-[0_0_16px_rgba(255,128,96,0.75)]"
                        ></span>

                        RestaurantOS Platform

                    </div>


                    <div
                        class="hidden
                               text-[8px]
                               uppercase
                               tracking-[0.26em]
                               text-orange-50/40
                               xl:block"
                    >
                        Simple · Moderno · Eficiente
                    </div>

                </div>


                <!-- ================================================== -->
                <!-- HERO -->
                <!-- ================================================== -->

                <div
                    class="mt-9
                           max-w-[760px]
                           xl:mt-11"
                >

                    <h2
                        class="!m-0
                               max-w-[800px]
                               !text-[37px]
                               !font-extrabold
                               !leading-[1.05]
                               !tracking-[-0.04em]
                               !text-[#fffaf5]
                               xl:!text-[47px]
                               2xl:!text-[53px]"
                    >

                        Una forma más inteligente de

                        <span
                            class="!text-[#ff8968]"
                        >
                            gestionar tu negocio gastronómico.
                        </span>

                    </h2>


                    <p
                        class="mt-5
                               max-w-[610px]
                               text-sm
                               leading-6
                               text-orange-50/75
                               xl:text-[15px]
                               xl:leading-7"
                    >
                        Desde la mesa hasta la cocina.
                        Centraliza operaciones, toma mejores decisiones
                        y haz crecer tu negocio sin importar
                        el tipo de gastronomía.
                    </p>

                </div>


                <!-- ================================================== -->
                <!-- FEATURES -->
                <!-- ================================================== -->

                <div
                    class="mt-7
                           grid
                           max-w-[650px]
                           grid-cols-2
                           gap-3"
                >

                    <!-- QR -->

                    <div
                        class="group
                               rounded-2xl
                               border border-white/[0.14]
                               bg-black/20
                               p-4
                               shadow-[0_15px_35px_rgba(0,0,0,0.12)]
                               backdrop-blur-[6px]
                               transition
                               duration-300
                               hover:-translate-y-0.5
                               hover:border-white/20
                               hover:bg-black/30"
                    >

                        <div
                            class="flex
                                   items-start
                                   justify-between"
                        >

                            <div
                                class="flex h-9 w-9
                                       items-center
                                       justify-center
                                       rounded-xl
                                       bg-[#ff805d]/15
                                       text-lg
                                       text-[#ff916f]"
                            >

                                <nz-icon
                                    nzType="qrcode"
                                    nzTheme="outline"
                                ></nz-icon>

                            </div>


                            <div
                                class="flex h-8 w-8
                                       items-center
                                       justify-center
                                       rounded-full
                                       border border-white/10
                                       bg-white/[0.05]
                                       text-xs
                                       text-white/60"
                            >

                                <nz-icon
                                    nzType="arrow-right"
                                    nzTheme="outline"
                                ></nz-icon>

                            </div>

                        </div>


                        <div
                            class="mt-3
                                   text-sm
                                   font-bold
                                   text-white"
                        >
                            Pedidos por QR
                        </div>


                        <div
                            class="mt-1
                                   text-[11px]
                                   leading-5
                                   text-orange-50/55"
                        >
                            Menos espera.
                            Más pedidos.
                            Más ventas.
                        </div>

                    </div>


                    <!-- KITCHEN -->

                    <div
                        class="group
                               rounded-2xl
                               border border-white/[0.14]
                               bg-black/20
                               p-4
                               shadow-[0_15px_35px_rgba(0,0,0,0.12)]
                               backdrop-blur-[6px]
                               transition
                               duration-300
                               hover:-translate-y-0.5
                               hover:border-white/20
                               hover:bg-black/30"
                    >

                        <div
                            class="flex
                                   items-start
                                   justify-between"
                        >

                            <div
                                class="flex h-9 w-9
                                       items-center
                                       justify-center
                                       rounded-xl
                                       bg-[#ff805d]/15
                                       text-lg
                                       text-[#ff916f]"
                            >

                                <nz-icon
                                    nzType="fire"
                                    nzTheme="outline"
                                ></nz-icon>

                            </div>


                            <div
                                class="flex h-8 w-8
                                       items-center
                                       justify-center
                                       rounded-full
                                       border border-white/10
                                       bg-white/[0.05]
                                       text-xs
                                       text-white/60"
                            >

                                <nz-icon
                                    nzType="arrow-right"
                                    nzTheme="outline"
                                ></nz-icon>

                            </div>

                        </div>


                        <div
                            class="mt-3
                                   text-sm
                                   font-bold
                                   text-white"
                        >
                            Cocina conectada
                        </div>


                        <div
                            class="mt-1
                                   text-[11px]
                                   leading-5
                                   text-orange-50/55"
                        >
                            Pedidos en tiempo real
                            y mayor eficiencia.
                        </div>

                    </div>


                    <!-- INVENTORY -->

                    <div
                        class="group
                               rounded-2xl
                               border border-white/[0.14]
                               bg-black/20
                               p-4
                               shadow-[0_15px_35px_rgba(0,0,0,0.12)]
                               backdrop-blur-[6px]
                               transition
                               duration-300
                               hover:-translate-y-0.5
                               hover:border-white/20
                               hover:bg-black/30"
                    >

                        <div
                            class="flex
                                   items-start
                                   justify-between"
                        >

                            <div
                                class="flex h-9 w-9
                                       items-center
                                       justify-center
                                       rounded-xl
                                       bg-[#ff805d]/15
                                       text-lg
                                       text-[#ff916f]"
                            >

                                <nz-icon
                                    nzType="bar-chart"
                                    nzTheme="outline"
                                ></nz-icon>

                            </div>


                            <div
                                class="flex h-8 w-8
                                       items-center
                                       justify-center
                                       rounded-full
                                       border border-white/10
                                       bg-white/[0.05]
                                       text-xs
                                       text-white/60"
                            >

                                <nz-icon
                                    nzType="arrow-right"
                                    nzTheme="outline"
                                ></nz-icon>

                            </div>

                        </div>


                        <div
                            class="mt-3
                                   text-sm
                                   font-bold
                                   text-white"
                        >
                            Inventario y ventas
                        </div>


                        <div
                            class="mt-1
                                   text-[11px]
                                   leading-5
                                   text-orange-50/55"
                        >
                            Controla insumos,
                            ventas y rentabilidad.
                        </div>

                    </div>


                    <!-- TEAM -->

                    <div
                        class="group
                               rounded-2xl
                               border border-white/[0.14]
                               bg-black/20
                               p-4
                               shadow-[0_15px_35px_rgba(0,0,0,0.12)]
                               backdrop-blur-[6px]
                               transition
                               duration-300
                               hover:-translate-y-0.5
                               hover:border-white/20
                               hover:bg-black/30"
                    >

                        <div
                            class="flex
                                   items-start
                                   justify-between"
                        >

                            <div
                                class="flex h-9 w-9
                                       items-center
                                       justify-center
                                       rounded-xl
                                       bg-[#ff805d]/15
                                       text-lg
                                       text-[#ff916f]"
                            >

                                <nz-icon
                                    nzType="team"
                                    nzTheme="outline"
                                ></nz-icon>

                            </div>


                            <div
                                class="flex h-8 w-8
                                       items-center
                                       justify-center
                                       rounded-full
                                       border border-white/10
                                       bg-white/[0.05]
                                       text-xs
                                       text-white/60"
                            >

                                <nz-icon
                                    nzType="arrow-right"
                                    nzTheme="outline"
                                ></nz-icon>

                            </div>

                        </div>


                        <div
                            class="mt-3
                                   text-sm
                                   font-bold
                                   text-white"
                        >
                            Equipo y sucursales
                        </div>


                        <div
                            class="mt-1
                                   text-[11px]
                                   leading-5
                                   text-orange-50/55"
                        >
                            Todos trabajando juntos,
                            desde un solo lugar.
                        </div>

                    </div>

                </div>


                <!-- ================================================== -->
                <!-- BUSINESS TYPES -->
                <!-- ================================================== -->

                <div class="mt-5">

                    <div
                        class="mb-2
                               text-[8px]
                               font-semibold
                               uppercase
                               tracking-[0.19em]
                               text-orange-50/45"
                    >
                        Para todo tipo de negocio gastronómico
                    </div>


                    <div
                        class="flex
                               flex-wrap
                               gap-2"
                    >

                        <span
                            class="rounded-full
                                   border border-white/15
                                   bg-black/15
                                   px-3 py-1.5
                                   text-[9px]
                                   text-orange-50/80
                                   backdrop-blur"
                        >
                            Restaurantes
                        </span>


                        <span
                            class="rounded-full
                                   border border-white/15
                                   bg-black/15
                                   px-3 py-1.5
                                   text-[9px]
                                   text-orange-50/80
                                   backdrop-blur"
                        >
                            Pollerías
                        </span>


                        <span
                            class="rounded-full
                                   border border-white/15
                                   bg-black/15
                                   px-3 py-1.5
                                   text-[9px]
                                   text-orange-50/80
                                   backdrop-blur"
                        >
                            Fast food
                        </span>


                        <span
                            class="rounded-full
                                   border border-white/15
                                   bg-black/15
                                   px-3 py-1.5
                                   text-[9px]
                                   text-orange-50/80
                                   backdrop-blur"
                        >
                            Cafeterías
                        </span>


                        <span
                            class="rounded-full
                                   border border-white/15
                                   bg-black/15
                                   px-3 py-1.5
                                   text-[9px]
                                   text-orange-50/80
                                   backdrop-blur"
                        >
                            Bares
                        </span>


                        <span
                            class="rounded-full
                                   border border-white/15
                                   bg-black/15
                                   px-3 py-1.5
                                   text-[9px]
                                   text-orange-50/80
                                   backdrop-blur"
                        >
                            Bebidas
                        </span>

                    </div>

                </div>


                <!-- ================================================== -->
                <!-- LOWER VISUAL AREA -->
                <!-- ================================================== -->

                <div
                    class="relative
                           mt-auto
                           flex min-h-[255px]
                           items-end
                           justify-between
                           pb-3
                           pt-10"
                >

                    <!-- ============================================== -->
                    <!-- BRAND MESSAGE -->
                    <!-- ============================================== -->

                    <div
                        class="max-w-[320px]
                               rounded-2xl
                               border border-white/[0.12]
                               bg-black/20
                               px-5 py-4
                               shadow-[0_20px_50px_rgba(0,0,0,0.16)]
                               backdrop-blur-[6px]"
                    >

                        <div
                            class="flex
                                   items-center
                                   gap-2"
                        >

                            <span
                                class="h-2 w-2
                                       rounded-full
                                       bg-[#ff8968]
                                       shadow-[0_0_14px_rgba(255,137,104,0.70)]"
                            ></span>


                            <span
                                class="text-[9px]
                                       font-semibold
                                       uppercase
                                       tracking-[0.18em]
                                       text-orange-50/50"
                            >
                                RestaurantOS
                            </span>

                        </div>


                        <div
                            class="mt-3
                                   text-[20px]
                                   font-bold
                                   leading-7
                                   tracking-[-0.025em]
                                   text-white"
                        >
                            Más control.
                            <br>
                            Mejor servicio.
                        </div>


                        <p
                            class="mt-2
                                   max-w-[270px]
                                   text-[11px]
                                   leading-5
                                   text-orange-50/55"
                        >
                            Tecnología pensada para que tu equipo
                            se concentre en lo que realmente importa:
                            atender mejor.
                        </p>

                    </div>


                    <!-- ============================================== -->
                    <!-- STATUS -->
                    <!-- ============================================== -->

                    <div
                        class="hidden
                               items-center
                               gap-3
                               rounded-full
                               border border-white/[0.12]
                               bg-black/20
                               px-4 py-2.5
                               shadow-[0_15px_40px_rgba(0,0,0,0.18)]
                               backdrop-blur-[6px]
                               xl:flex"
                    >

                        <span
                            class="relative
                                   flex h-2.5 w-2.5"
                        >

                            <span
                                class="absolute
                                       inline-flex
                                       h-full w-full
                                       animate-ping
                                       rounded-full
                                       bg-emerald-400
                                       opacity-40"
                            ></span>


                            <span
                                class="relative
                                       inline-flex
                                       h-2.5 w-2.5
                                       rounded-full
                                       bg-emerald-400"
                            ></span>

                        </span>


                        <div>

                            <div
                                class="text-[8px]
                                       text-orange-50/40"
                            >
                                Plataforma
                            </div>


                            <div
                                class="text-[10px]
                                       font-semibold
                                       text-white"
                            >
                                Lista para operar
                            </div>

                        </div>

                    </div>

                </div>


                <!-- ================================================== -->
                <!-- FOOTER -->
                <!-- ================================================== -->

                <div
                    class="mt-4
                           flex
                           items-center
                           justify-between
                           text-[8px]
                           uppercase
                           tracking-[0.18em]
                           text-orange-50/35"
                >

                    <span>
                        RestaurantOS © 2026
                    </span>


                    <span>
                        Hospitalidad que impulsa tu negocio
                    </span>

                </div>

            </div>

        </section>

    </div>

</div>